/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VocabImportBatchDto = {
  /**
   * 배치 ID
   */
  id: string;
  /**
   * 배치 유형
   */
  type: VocabImportBatchDto.type;
  /**
   * 상태
   */
  status: VocabImportBatchDto.status;
  /**
   * 전체 항목 수
   */
  totalCount: number;
  /**
   * 성공
   */
  succeededCount: number;
  /**
   * 최종 실패 (재시도 소진)
   */
  failedCount: number;
  /**
   * 검수 미달 — 리뷰 대기
   */
  reviewCount: number;
  /**
   * 처리 불가 (레퍼런스 없음 등)
   */
  invalidCount: number;
  /**
   * 이미 존재해 건너뜀
   */
  skippedCount: number;
  /**
   * 생성 시각
   */
  createdAt: string;
};
export namespace VocabImportBatchDto {
  /**
   * 배치 유형
   */
  export enum type {
    IMPORT = "import",
    RETAG = "retag",
    REGEN = "regen",
    MEDIA = "media",
  }
  /**
   * 상태
   */
  export enum status {
    PROCESSING = "processing",
    COMPLETED = "completed",
  }
}
